/**
 * Format a date string to a user-friendly local time string.
 * @param dateString The date string to format
 * @returns Formatted date string or '--' for invalid input
 */
export const formatToUserLocalTime = (dateString: string): string => {
    if (!dateString) return '--'
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return '--'

    const options: Intl.DateTimeFormatOptions = {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZoneName: 'short',
    }

    return date.toLocaleString('en-US', options)
}
